import className from 'classnames/bind';
import style from '../style/Login.module.scss';
import {useSelector} from "react-redux";
import {notification} from "antd";
import {AuthLoginForm} from "~/features/Auth/components";
import {authErrorSelector} from "~/reduxs/Auth/authSlice";
import {globalNavigate} from "~/routes/GlobalHistory";
import {
	Image
} from "~/components";
import {FontAwesomeIcon} from "../../../components";
import {useEffect} from "react";
const cn = className.bind(style);

function Login() {

	const error = useSelector(authErrorSelector);

	if (error) {
		notification.error({
			message: 'Thất bại',
			description: error
		});
	}

	const isLoggedIn = Boolean(localStorage.getItem('access_token'));

    useEffect(() => {
        if (isLoggedIn)
        {
            globalNavigate(process.env.REACT_APP_HOMEPAGE+"/");
        }
    }, [isLoggedIn]);


	return (
		<div className={cn('login-container')}>
            <div className={cn('login-form')}>
                <div className={cn('login-form-wrapper')}>
                    <div className="d-flex align-items-center gap-1 justify-content-start mb-3">
                        <span className="text-4xl color-theme"><FontAwesomeIcon icon="fa-light fa-computer" /></span>
                        <span className="text-1xl fw-bold">Giò Chả Tuyết</span>
                    </div>
                    <div className="text-left mb-4">
                        <h1 className="text-3xl fw-bold">Chào mừng trở lại</h1>
                        <p className="mt-1 text-base color-grey">Đăng nhập để bán hàng thông minh hơn</p>
                    </div>
                    <div className={cn('login-form-inner')}>
                        <AuthLoginForm/>
                    </div>
                </div>
            </div>
            <div className={cn('login-connect')}>
                <Image className={cn('banner')} src="https://giochatuyet.com/uploads/source/slider/slider-cha-bo-da-nang-gio-cha-tuyet.jpg"/>
                <div className={cn('mask')}></div>
                <div className={cn('content')}>
                    {/*<h2 className="text-4xl font-bold leading-tight">Tối ưu hóa chuỗi cung ứng của bạn</h2>*/}
                    {/*<p className="mt-4 text-lg text-slate-200">Nền tảng toàn diện để quản lý logistic xuất nhập khẩu*/}
                    {/*    đường biển một cách hiệu quả và minh bạch.</p>*/}
                </div>
            </div>
        </div>
    )
}

export default Login;